const getRuntimeConfig = () => {
  if (typeof window === "undefined") {
    return {};
  }

  return window.__ENV__ || {};
};

const getConfiguredBaseUrl = () => {
  const runtimeConfig = getRuntimeConfig();
  const apiBaseUrl = (runtimeConfig.apiBaseUrl || "").trim();
  const baseUrl = (runtimeConfig.BASE_URL || "").trim();

  return apiBaseUrl || baseUrl || "";
};

const configuredBaseUrl = getConfiguredBaseUrl();

const appConfig = {
  apiBaseUrl: configuredBaseUrl,
  baseUrl: configuredBaseUrl,
};

export default appConfig;
